'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ApplicationManager = function () {
  function ApplicationManager() {
    _classCallCheck(this, ApplicationManager);

    this.ondownloading = function () {};
    this.onprogress = function () {};
    this.onupdateready = function () {};
  }

  _createClass(ApplicationManager, [{
    key: 'init',
    value: function init() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        var timeout = void 0;
        var clearEventListeners = void 0;

        var success = function success(e) {
          clearTimeout(timeout);
          clearEventListeners();
          resolve(e);
        };

        timeout = setTimeout(success, 2000);

        var failure = function failure(e) {
          clearTimeout(timeout);
          clearEventListeners();
          reject(e);
        };

        clearEventListeners = function clearEventListeners() {
          applicationCache.removeEventListener('updateready', _this.onupdateready);
          applicationCache.removeEventListener('noupdate', success);
          applicationCache.removeEventListener('error', failure);
          applicationCache.removeEventListener('obsolete', success);
          applicationCache.removeEventListener('cached', success);
          applicationCache.removeEventListener('downloading', _this.ondownloading);
          applicationCache.removeEventListener('progress', _this.onprogress);
        };

        if (typeof applicationCache !== 'undefined') {
          applicationCache.addEventListener('updateready', _this.onupdateready);
          applicationCache.addEventListener('noupdate', success);
          applicationCache.addEventListener('error', failure);
          applicationCache.addEventListener('obsolete', success);
          applicationCache.addEventListener('cached', success);
          applicationCache.addEventListener('downloading', _this.ondownloading);
          applicationCache.addEventListener('progress', _this.onprogress);

          if (applicationCache.status === applicationCache.UNCACHED || applicationCache.status === applicationCache.IDLE) {
            resolve();
          }
        } else {
          resolve();
        }
      });
    }
  }, {
    key: 'swapCache',
    value: function swapCache() {
      applicationCache.swapCache();
    }
  }]);

  return ApplicationManager;
}();

exports.default = ApplicationManager;


//////////////////
// WEBPACK FOOTER
// ./js/lib/ApplicationManager.js
// module id = 1
// module chunks = 0